import React from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "gatsby";

const CookieConsentBanner = () => {
  return (
    <CookieConsent
      disableStyles
      disableButtonStyles
      buttonText="OK"
      cookieName="gatsby-gdpr-coockie"
      buttonClasses="bg-black transition duration-300 px-4 py-2 rounded-full text-base font-semibold text-white px-6 py-2 hover:bg-black/80"
      containerClasses="bg-white max-w-[28rem] flex items-center gap-5 fixed z-50 bottom-0 left-0 p-3 ms-0 ms-3 mb-0 mb-3 bg-white/40 backdrop-blur-xl shadow-lg rounded-xl max-sm:hidden"
    >
      <p className="text-black text-sm">
        Debt Redemption uses cookies to pursonalize your experience. By using
        our website. You accept our use of cookies as described in our{" "}
        <Link
          className="text-sky-700 hover:text-sky-800 transition underline"
          to="/privacy-policy/"
        >
          Privacy Policy
        </Link>
      </p>
    </CookieConsent>
  );
};

export default CookieConsentBanner;
